import { type SvgIconProps } from '@mui/material';
import React from 'react';

function DocumentsIcon(props: SvgIconProps) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.80521 8.89062H31.0923C31.3539 8.89062 31.6052 8.99317 31.7921 9.17626L33.0167 10.3758C33.2087 10.5639 33.3169 10.8214 33.3169 11.0902V45.7025C33.3169 45.9622 33.2158 46.2117 33.0351 46.3983L31.7952 47.6782C31.6068 47.8727 31.3477 47.9824 31.0769 47.9824H4.82076C4.53733 47.9824 4.26721 47.8621 4.07757 47.6515L2.9443 46.3927C2.77898 46.209 2.6875 45.9707 2.6875 45.7236V11.0688C2.6875 10.8127 2.78576 10.5663 2.96202 10.3805L4.07973 9.20238C4.26856 9.00334 4.53086 8.89062 4.80521 8.89062Z"
        fill="#FF5200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5605 2.5V37.4863H41.6865V11.8292L33.1982 2.5H15.5605ZM14.0605 0C13.5083 0 13.0605 0.447716 13.0605 1V38.9863C13.0605 39.5386 13.5083 39.9863 14.0605 39.9863H43.1865C43.7388 39.9863 44.1865 39.5386 44.1865 38.9863V11.2489C44.1865 11 44.0937 10.7601 43.9262 10.576L34.601 0.327011C34.4115 0.118728 34.1429 0 33.8613 0H14.0605ZM37.1651 17.1797H24.1875V14.6797H37.1651V17.1797ZM19.6406 17.1797H22.1406V14.6797H19.6406V17.1797ZM22.1406 23.3594H19.6406V20.8594H22.1406V23.3594ZM19.6406 29.543H22.1406V27.043H19.6406V29.543ZM37.1651 23.3594H24.1875V20.8594H37.1651V23.3594ZM24.1875 29.543H37.1651V27.043H24.1875V29.543Z"
        fill="black"
      />
    </svg>
  );
}

export default DocumentsIcon;
